export function hasEditorContent(content) {
  if (!content) return false;

  const text = content
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

  return text.length > 0 || /<img\b/i.test(content);
}
